<template>
  <Layout>
    <v-app v-if="this.user">
      <AdminDashboard v-if="this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1'"></AdminDashboard>
      <SalesPersonDashboard v-if="this.user.RoleGroupId === 2 || this.user.RoleGroupId === '2'"></SalesPersonDashboard>
      <CustomerDashboard v-if="this.user.RoleGroupId === 3 || this.user.RoleGroupId === '3'"></CustomerDashboard>
    </v-app>
  </Layout>
</template>

<script>
import Layout from '@/pages/layout/main.vue';
import AdminDashboard from "@/components/dashboard/Dashboards/AdminDashboard";
import SalesPersonDashboard from "@/components/dashboard/Dashboards/SalesPersonDashboard";
import CustomerDashboard from "@/components/dashboard/Dashboards/CustomerDashboard";
import {mapState} from "vuex";


export default {

  components: {
    Layout,
    AdminDashboard,
    SalesPersonDashboard,
    CustomerDashboard
  },

  mounted() {

  },

  computed:{
    ...mapState("auth",["user"])
  },

  data() {
    return {

    }
  },

  methods: {

  },

  watch:{

  }

}


</script>